import React, { useState } from 'react';
import styled, { CSSObject } from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { selectIdName, useAuthStore } from '@nike/aegis-auth-react';
import aegisClient from '../../auth/client';

const StyledDiv = styled.div(
  (): CSSObject => ({
    position: 'relative',
    display: 'inline-block'
  })
);

const Dropdown = styled.div({
  position: 'absolute',
  top: '50px',
  right: '0',
  backgroundColor: '#FAFAFA',
  border: '1px solid #ccc',
  borderRadius: '4px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  zIndex: 1000,
  width: '200px',
  color:'#707072'
});

const DropdownItem = styled.div({
  padding: '10px',
  fontSize: '16px',
  borderBottom: '1px solid #eee',
  cursor: 'pointer',
  textAlign: 'center',
  '&:first-of-type': {
    fontWeight: 'bold',
    overflow: 'auto'
  },
  '&:last-child': {
    borderBottom: 'none',
  }
});

const UserProfile = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const navigate = useNavigate();

  // userName is fetched from the auth store
  const userName = useAuthStore(selectIdName);

  const toggleDropdown = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };

  const handleSignOut = () => {
    aegisClient.logout().then(() => {
      return navigate('/logout');
    })
  }

  return(
      <StyledDiv>
        <i
          data-testid="user-profile"
          className="g72-profile"
          aria-label="user-profile"
          style={{ fontSize: '40px', cursor: 'pointer', color: '#707072' }}
          onClick={toggleDropdown}
        ></i>
        {isDropdownOpen && (
          <Dropdown>
            <DropdownItem>
              <strong>{userName}</strong>
            </DropdownItem>
            <DropdownItem onClick={handleSignOut}>Sign Out</DropdownItem>
          </Dropdown>
        )}
      </StyledDiv>
  )
}

export default UserProfile;